<template>
  <div class="term">
    <div class="plan-condition py-4 border-b border-section_border">
      <h2 class="section-title text-lg text-center">
        {{$t('tour_ai_taxi_title')}}
      </h2>
    
      <div class="p-4 border-b border-section_border">
          
        <h3>{{$t('tour_ai_taxi_term1')}}</h3>
        <p>{{$t('tour_ai_taxi_term1_text')}}</p>

        <h3>{{$('tour_ai_taxi_term2')}}</h3>
        <p>
          {{$t('tour_ai_taxi_term2_text')}}
        </p>
        <p>
          {{$t('tour_ai_taxi_term2_text2')}}
        </p>
        <h3>{{$t('tour_ai_taxi_term3')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term3_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term4')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term4_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term5')}}</h3>
        <p>
          {{$t('tour_ai_taxi_term5_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term6')}}</h3>
        <p>
          {{$t('tour_ai_taxi_term6_text')}}
        </p>
        <h3>{{$t('tour_ai_taxi_term7')}}</h3>
        <p>
          {{$t('tour_ai_taxi_term7_text')}}
        </p>
        <h3>{{$t('tour_ai_taxi_term8')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term8_text')}}
        </p>
        <h3>{{$t('tour_ai_taxi_term9')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term9_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term10')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term10_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term11')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term11_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term12')}} </h3>
        <p>
        {{$t('tour_ai_taxi_term12_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term13')}} </h3>
        <p>
        {{$t('tour_ai_taxi_term13_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term14')}} </h3>
        <p>
          {{$t('tour_ai_taxi_term14_text')}}
        </p>


        <h3>{{$t('tour_ai_taxi_term15')}} </h3>
        <p>
          {{$t('tour_ai_taxi_term15_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term16')}}</h3>
        <p>
        {{$t('tour_ai_taxi_term16_text')}}
        </p>

        <h3>{{$t('tour_ai_taxi_term17')}} </h3>
        <p>
        {{$t('tour_ai_taxi_term17_text')}}
        </p>

        <h3>{{$t('tour_by_law')}} </h3>
        <p>
        {{$t('tour_ai_taxi_by_law_text')}}
        </p>

        <p>{{$t('tour_above')}}</p>

      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../constants";

export default {
  methods: {
    back: function () {
        this.$router.push({ path: '/plans' })
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>
